<template>
  <div class="internal-ot-listing" v-if="getPermission('engineer:view') || getPermission('visit:view')">
    <v-container fluid class="custom-bthrust-style">
      <v-container class="pr-0">
        <v-layout class="justify-end">
          <div class="mx-2 my-2">
            <DateRangePicker placeholder="Date Range" v-model="dates" v-on:update:model-value="getOrListing()"
              v-on:click:clear="clearFilter('dates')"></DateRangePicker>
          </div>
          <div class="mr-2 my-2">
            <v-text-field v-model.trim="filter.search" v-on:click:clear="clearFilter('search')" clearable dense filled
              flat :placeholder="type === 'visit' ? 'Search engineer' : 'Search visit'
                " hide-details solo :disabled="pageLoading" color="cyan" @keydown.enter="getOrListing"
              @keydown.tab="getOrListing"></v-text-field>
          </div>
          <div class="ml-2 my-2">
            <v-btn depressed class="custom-bold-button white--text" color="cyan" tile :disabled="pageLoading"
              v-on:click="getOrListing">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </div>
          <div class="ml-2 mt-1">
            <v-icon dark left style="font-size: 40px" :disabled="pageLoading" class="custom-bold-button"
              v-on:click="downloadPDFNew()" color="red white--text">mdi-file-pdf-box</v-icon>
          </div>
        </v-layout>
      </v-container>
      <v-simple-table fixed-header height="67vh">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="simple-table-th text-center">
                {{ type === "visit" ? "Technician" : "Visit ID" }}
              </th>
              <th class="simple-table-th">Actual Date / Time</th>
              <th class="simple-table-th">Start Time</th>
              <th class="simple-table-th">End Time</th>
              <th class="simple-table-th text-center">Duration</th>
              <th class="simple-table-th text-center">OT Rate Type</th>
              <th class="simple-table-th text-center">Total Time</th>
              <th class="simple-table-th text-center">Summary</th>
              <th class="simple-table-th text-center">Status</th>
              <th class="simple-table-th text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="otList.length > 0">
              <!-- Loop groups -->
              <template v-for="(group, gIndex) in otList">
                <!-- Loop rows -->
                <tr v-for="(row, rIndex) in group.rows" :key="gIndex + '-' + rIndex" :class="{
                  'orange_lighten-5': gIndex % 2 === 0,
                }">
                  <td v-if="rIndex === 0" :rowspan="group.rows.length"
                    class="simple-table-td text-center border-right-thin">
                    <div class="d-flex justify-center align-center">
                      <template v-if="type === 'engineer'">
                        <Barcode :barcode="group.visit_barcode" route="visit.detail" :id="group.visit_id" />
                      </template>
                      <template v-else>
                        <div class="d-flex flex-column align-center">
                          <Barcode :barcode="group.engineer_barcode" route="engineer.detail" :id="group.engineer_id" />
                          <span v-if="group.engineer_display_name" class="mt-1">
                            {{ group.engineer_display_name }}
                          </span>
                        </div>
                      </template>
                    </div>
                  </td>

                  <td v-if="rIndex === 0" :rowspan="group.rows.length"
                    class="simple-table-td text-center border-right-thin border-left-thin">
                    <div class="m-0 max-content-width" v-if="group.actual_start_date || group.actual_end_date">
                      <p class="m-0 text-left">
                        <span class="m-0">
                          <b> Started At : </b>
                          <template v-if="group.actual_start_date">
                            <v-chip small outlined color="red" label>
                              {{ formatDateValue(group.actual_start_date) }}
                              {{ formatDateStartTime(group.actual_start_date) }}
                            </v-chip>
                          </template>
                          <template v-else>
                            <em class="text-muted"> no started at</em>
                          </template>
                        </span>
                      </p>
                      <p class="m-0 mt-1 text-left">
                        <span class="m-0">
                          <b> Ended At &nbsp;&nbsp;: </b>
                          <template v-if="group.actual_end_date">
                            <v-chip small outlined color="green" label>
                              {{ formatDateValue(group.actual_end_date) }}
                              {{ formatDateStartTime(group.actual_end_date) }}
                            </v-chip>
                          </template>
                          <template v-else>
                            <em class="text-muted"> no ended at</em>
                          </template>
                        </span>
                      </p>
                    </div>
                    <em v-else class="text-muted">No actual date</em>
                  </td>

                  <td class="simple-table-td">
                    {{ formatOtDateTime(row.ot_start) }}
                  </td>

                  <td class="simple-table-td">
                    {{ formatOtDateTime(row.ot_end) }}
                  </td>

                  <td class="simple-table-td text-center">
                    {{ row.total_time || "—" }}
                  </td>
                  <td class="simple-table-td text-center">
                    {{ row.rate || "—" }}
                  </td>

                  <td v-if="rIndex === 0" :rowspan="group.rows.length"
                    class="simple-table-td text-center border-right-thin border-left-thin font-size-20">
                    <div v-if="group.is_max_ot_applied">
                      <b>{{ group.final_ot_time }}</b>
                      <div class="font-size-11 grey--text text-decoration-line-through font-weight-400">
                        {{ group.total_time }}
                      </div>
                    </div>
                    <b v-else>{{ group.total_time }}</b>
                  </td>

                  <td v-if="rIndex === 0" :rowspan="group.rows.length"
                    class="simple-table-td text-center border-left-thin border-right-thin font-size-14">
                    <div><b>OT 1.5 :</b> {{ group.ot_1_5_time }}</div>
                    <div><b>OT 2.0 :</b> {{ group.ot_2_0_time }}</div>
                    <div class="d-flex align-center justify-center">
                      <div><b>Total OT:</b> {{ group.final_ot_time }}</div>
                      <!--  <v-tooltip
                        top
                        content-class="custom-top-tooltip"
                        v-if="group.is_max_ot_applied"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            color="orange darken-2"
                            class="ml-1 cursor-pointer"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-alert-circle
                          </v-icon>
                        </template>
                        <span>{{
                          group.capped_reason ||
                          `Actual OT was ${group.actual_ot_time} hrs, but capped to ${group.final_ot_time} hrs due to Visit Max OT Limit.`
                        }}</span>
                      </v-tooltip> -->
                    </div>
                    <div v-if="group.is_max_ot_applied" class="mt-1">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-chip x-small color="orange lighten-4" text-color="orange darken-4"
                            class="font-weight-600 px-1 cursor-pointer" v-bind="attrs" v-on="on">
                            Max OT Capped ({{ group.max_ot_hours }}h)
                          </v-chip>
                        </template>
                        <span>{{
                          group.capped_reason ||
                          `Actual OT was ${group.actual_ot_time} hrs, but capped to ${group.final_ot_time} hrs due to
                          Visit Max OT Limit.`
                        }}</span>
                      </v-tooltip>
                    </div>
                  </td>

                  <td class="simple-table-td text-center border-right-thin border-left-thin">
                    <v-chip v-if="row.status === 'approved'" color="#00a65a" text-color="white" small label
                      class="font-weight-600 text-uppercase">
                      Approved
                    </v-chip>
                    <v-chip v-else-if="row.status === 'rejected'" color="#f44336" text-color="white" small label
                      class="font-weight-600 text-uppercase">
                      Rejected
                    </v-chip>
                    <v-chip v-else color="#f6c23e" text-color="white" small label
                      class="font-weight-600 text-uppercase">
                      Pending
                    </v-chip>
                  </td>

                  <td class="simple-table-td text-center">
                    <div class="d-flex align-center justify-center">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-on="on" v-bind="attrs" class="d-inline-block">
                            <v-btn icon small color="cyan" class="mx-1" @click="UpdateOt(row)" :disabled="pageLoading ||
                              (row.status && row.status !== 'pending')
                              ">
                              <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                          </span>
                        </template>
                        <span>Edit</span>
                      </v-tooltip>

                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-on="on" v-bind="attrs" class="d-inline-block">
                            <v-btn icon small color="green" class="mx-1" @click="openStatusDialog(row, 'approved')"
                              :disabled="pageLoading ||
                                !canManageOt(row, group) ||
                                (row.status && row.status !== 'pending')
                                ">
                              <v-icon small>mdi-check-circle-outline</v-icon>
                            </v-btn>
                          </span>
                        </template>
                        <span>{{
                          !canManageOt(row, group)
                            ? "SBU is not match"
                            : "Approve"
                        }}</span>
                      </v-tooltip>

                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <span v-on="on" v-bind="attrs" class="d-inline-block">
                            <v-btn icon small color="red" class="mx-1" @click="openStatusDialog(row, 'rejected')"
                              :disabled="pageLoading ||
                                !canManageOt(row, group) ||
                                (row.status && row.status !== 'pending')
                                ">
                              <v-icon small>mdi-close-circle-outline</v-icon>
                            </v-btn>
                          </span>
                        </template>
                        <span>{{
                          !canManageOt(row, group)
                            ? "SBU is not match"
                            : "Reject"
                        }}</span>
                      </v-tooltip>
                    </div>
                  </td>
                </tr>
              </template>
            </template>

            <!-- Empty -->
            <template v-else>
              <tr>
                <td colspan="10">
                  <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                    <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                    Uhh... There are no history at the moment.
                  </p>
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <ListingFooter :dataLoading="pageLoading" :currentPage="current_page" :totalPages="total_pages"
        :showingFrom="showingFrom" :showingTo="showingTo" :totalRows="total_rows" removePage></ListingFooter>
      <UpdateOT :document-dialog="ot_dialog" :ot-row="otRow" @close="ot_dialog = false" @success="getOrListing()" />
      <OtApprovedRejectDialog :status-dialog="statusDialog" :status="selectedStatus" :ot-data="selectedOtGroup"
        @close="statusDialog = false" @success="getOrListing()" />
    </v-container>
  </div>
</template>

<script>
import UpdateOT from "@/view/pages/engineer/Update-Ot";
import JwtService from "@/core/services/jwt.service";
import { QUERY } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingFooter from "@/view/pages/partials/Listing-Footer";
import { PaginationEventBus } from "@/core/lib/pagination.lib";
import DateRangePicker from "@/view/components/DateRangePicker";
import moment from "moment-timezone";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import Barcode from "@/view/pages/partials/Barcode.vue";
import OtApprovedRejectDialog from "@/view/pages/partials/Ot-Approved-Reject-Dialog.vue";

export default {
  mixins: [CommonMixin],
  data() {
    return {
      loginUser: {},
      ot_dialog: false,
      dates: [],
      pageLoading: false,
      otList: new Array(),
      filter: {
        search: null,
      },
      per_page: 10,
      current_page: 1,
      offset: 0,
      total_pages: 0,
      total_rows: 0,
      otRow: {},
      statusDialog: false,
      selectedStatus: "",
      selectedOtGroup: {},
    };
  },
  components: {
    ListingFooter,
    DateRangePicker,
    Barcode,
    UpdateOT,
    OtApprovedRejectDialog,
  },
  props: {
    type: {
      required: false,
      type: String,
      default: "engineer",
    },
    type_id: {
      required: false,
      type: Number,
      default: 0,
    },
  },
  watch: {
    type_id() {
      let type_id = this.lodash.toSafeInteger(this.type_id);
      if (type_id > 0) {
        this.getOrListing();
      }
    },
  },
  methods: {
    canManageOt(row, group = {}) {
      const admin_user = this.loginUser;

      if (!admin_user) {
        return false;
      }
      //  console.log("admin_user", admin_user)
      const isSbuHead = admin_user.is_sbu_head === true

      const userSbu = admin_user.sbu ? Number(admin_user.sbu) : null;
      const technicianSbu = row?.technician_sbu
        ? Number(row.technician_sbu)
        : group?.technician_sbu
          ? Number(group.technician_sbu)
          : null;

      // console.log("technicianSbu", technicianSbu)
      if (isSbuHead && userSbu && technicianSbu && userSbu === technicianSbu) {
        return true;
      }

      return false;
    },
    formatDateValue(date) {
      if (!date) return "";
      const m = moment(date);
      if (!m.isValid()) return "";
      const dateFormat = this.dateFormat || "DD/MM/YYYY";
      return m.format(dateFormat);
    },
    formatDateStartTime(date) {
      if (!date) return "";
      const m = moment(date);
      if (!m.isValid()) return "";
      return m.format("hh:mm A");
    },
    UpdateOt(row) {
      this.otRow = row;
      this.ot_dialog = true;
    },
    openStatusDialog(group, status) {
      this.selectedOtGroup = group;
      this.selectedStatus = status;
      this.statusDialog = true;
    },
    downloadPDFNew() {
      if (this.lodash.isEmpty(this.dates) === false) {
        if (moment(this.dates[0]).isAfter(this.dates[1])) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("End Date must be after Start Date.")
          );
          return false;
        }
      }

      let pdfRoute = "engineer-ot-pdf/";
      let downloadURL = process.env.VUE_APP_API_URL + pdfRoute + this.type_id;
      downloadURL = new URL(downloadURL);
      const token = JwtService.getToken();
      downloadURL.searchParams.append("type", this.type);

      if (this.dates.length > 0 && this.dates[0] && this.dates[1]) {
        downloadURL.searchParams.append("start_date", this.dates[0]);
        downloadURL.searchParams.append("end_date", this.dates[1]);
      }
      if (this.filter?.search) {
        downloadURL.searchParams.append("search", this.filter?.search);
      }

      downloadURL.searchParams.append("token", token);
      window.open(downloadURL, "_blank");
    },

    clearFilter(field) {
      const _this = this;
      switch (field) {
        case "search":
          _this.filter.search = null;
          break;
        case "dates":
          _this.dates = [];
          break;
      }
      _this.getOrListing();
    },
    getOrListing() {
      const _this = this;

      if (_this.lodash.isEmpty(_this.dates) === false) {
        if (moment(_this.dates[0]).isAfter(_this.dates[1])) {
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("End Date must be after Start Date.")
          );
          return false;
        }
      }
      _this.pageLoading = true;
      _this.otList = [];
      const requestUrl = `engineer/${_this.type_id}/ot-listing`;
      _this.$store
        .dispatch(QUERY, {
          url: requestUrl,
          data: {
            per_page: _this.per_page,
            current_page: _this.current_page,
            search: _this.filter.search,
            start_date: _this.dates[0] || null,
            end_date: _this.dates[1] || null,
            type: this.type ?? null,
          },
        })
        .then(({ data }) => {
          _this.offset = data.offset;
          _this.otList = data.rows;
          _this.total_pages = Math.ceil(data.total_rows / data.per_page);
          _this.current_page = data.current_page;
          _this.total_rows = data.total_rows;
          if (data.login_user) {
            _this.loginUser = data.login_user;
          }
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },
  beforeDestroy() {
    PaginationEventBus.$off("update:pagination");
  },
  mounted() {
    const _this = this;
    _this.getOrListing();

    PaginationEventBus.$on("update:pagination", (param) => {
      _this.current_page = param;
      _this.getOrListing();
    });
  },
  computed: {
    showingFrom() {
      return this.lodash.isEmpty(this.otList) === false ? this.offset + 1 : 0;
    },
    showingTo() {
      return this.offset + (this.otList ? this.otList.length : 0);
    },
  },
};
</script>

<style scoped>
.custom-ot-action-btn {
  min-width: 80px !important;
  height: 28px !important;
  font-size: 11px !important;
  letter-spacing: 0.5px !important;
  border-radius: 4px !important;
}

::v-deep .v-data-table tbody tr:not(.orange_lighten-5):hover {
  background: transparent !important;
}

::v-deep .v-data-table button.v-btn.v-btn--disabled,
::v-deep button.v-btn.v-btn--icon.v-btn--disabled {
  border: none !important;
}
</style>
